import { createContext } from 'react'
const QueryContext = createContext(null)

export default QueryContext
